import { Listing } from "@app/data/listing";
import { CartItem } from "shopping/cart-item";

export class BulkPrice extends Listing {
  type: string;
  amount: number;
  min_quantity: number;
  max_quantity: number;
}

export class ItemListing extends Listing {
  category: string;
  quantity: number;
  hasVariants: boolean;
  bulk_prices: BulkPrice[];
}

export class ListingCartItem extends CartItem {
  public itemListing: ItemListing;
  public id: string;
  public variation: any;
  public option: any;
  public quantity: number = 0;
  public price: number = 0;

  constructor(itemData: any) {
    super();
    this.id = itemData.id;
    this.itemListing = itemData.itemListing;
    this.variation = itemData.variation;
    this.option = itemData.option;
    this.quantity = itemData.quantity;
    this.price = itemData.price;
  }

  public getId(): any {
    return this.id;
  }

  public getName(): string {
    return (
      this.itemListing.title + " " + (this.option ? this.option.title : "")
    );
  }

  getBulkPrice(bulk_price) {
    switch (bulk_price.type) {
      case "price_discount":
        return this.price - bulk_price.amount;
      case "percentage_discount":
        return this.price - (bulk_price.amount / 100) * this.price;
      case "fixed_price":
        return bulk_price.amount;
    }
  }

  public getPrice(): number {
    let price = this.price;
    if (this.itemListing.bulk_prices) {
      this.itemListing.bulk_prices.forEach((bulk_price) => {
        if (
          this.quantity >= bulk_price.min_quantity &&
          this.quantity <= bulk_price.max_quantity
        ) {
          price = this.getBulkPrice(bulk_price);
        }
      });
    }
    return Number.isNaN(price) ? 0 : price;
  }

  public setQuantity(quantity: number): any {
    this.quantity = quantity;
  }

  public getQuantity(): number {
    return this.quantity;
  }

  public getImage(): string {
    return this.itemListing.main_image;
  }
}

export class Customer {
  public id: string;
  public email: string;
  public company_name: string;
  public first_name: string;
  public last_name: string;
  public phone_number: string;
  public address_first_line: string;
  public address_second_line: string;
  public zip_code: string;
  public province_state: string;
  public iso_country_code: string;
  public city: string;
}
